import React from "react"
import { formatMoney } from "./format"

// Net/fees totals for the current filter set, plus the row count. Totals are
// single-currency (the dominant one) — see Partners::TransactionsQuery#totals.
export function SummaryBar({ totals, total, copy }) {
  const currency = totals?.currency
  const card = "rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4"
  const label = "text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400"
  const value = "mt-1 text-lg font-semibold text-gray-900 dark:text-gray-100"

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
      <div className={card}>
        <div className={label}>{copy.summary.net}</div>
        <div className={value}>{formatMoney(totals?.net_cents, currency)}</div>
      </div>
      <div className={card}>
        <div className={label}>{copy.summary.fees}</div>
        <div className={value}>{formatMoney(totals?.fees_cents, currency)}</div>
      </div>
      <div className={card}>
        <div className={label}>{copy.summary.count}</div>
        <div className={value}>{total?.toLocaleString() ?? "—"}</div>
      </div>
    </div>
  )
}
